/** @module Specification/CareAndComposition/CompositionPerLanguageRenderer */
define([
    "dojo/_base/declare",
    "csi/heading/StringTextarea"
], function(declare,StringRen) {

    return declare(StringRen, {

        /**
         * Change index to sys id language
         * @param {Context} ctx
         * @param {Heading} h
         */
        reserveContext: function(ctx, h) {
            ctx.pushParams().setNodeURL(ctx.getParentURL());
            ctx.keyValue = ctx.getNodeContext().SysID;
        },

        /**
         * Return context changed above
         * @param {Context} ctx
         * @param {Heading} h
         */
        releaseContext: function(ctx, h) {
            ctx.pop();
            ctx.keyValue = null;
        },

        /**
         * Disable filtering
         * @param {Context} ctx
         * @param {Heading} h
         * @param {Spec} spec
         */
        getQuerySpec: function(ctx, h, spec) {
            return null;
        }

    });
});